import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";

export const interfaceConfig: InterfaceConfig = {
  name: "kapital_partners",
  home_url: "/solicita_tu_credito",
  interest_rate: 0,
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_otVp4fvzT",
      userPoolClientId: "1iefuism39b8rmifi00lpnpm48",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "",
      userPoolClientId: "",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
